import {Controller} from "@hotwired/stimulus"

// Builds the per-org Claude.ai / ChatGPT connector URL as the user picks an
// organization, keeping a visible display and a hidden clipboard source in sync.
// No org is selected by default; the URL appears once the user picks one.
//
//   <div data-controller="mcp-connector-url clipboard"
//        data-mcp-connector-url-base-value="https://…/api/mcp">
//     <select data-mcp-connector-url-target="select"
//             data-action="change->mcp-connector-url#update">…</select>
//     <code   data-mcp-connector-url-target="display"></code>
//     <input  data-mcp-connector-url-target="source" ...>   (clipboard source)
//   </div>
export default class extends Controller {
    static targets = ['select', 'display', 'source']
    static values = {base: String}

    connect() {
        this.update()
    }

    update() {
        const slug = this.currentSlug()
        const url = slug ? `${this.baseValue}/${slug}` : ""
        if (this.hasDisplayTarget) this.displayTarget.textContent = url || "Select an organization above"
        if (this.hasSourceTarget) this.sourceTarget.value = url
    }

    // Read the selected slug from Tom Select if it has upgraded the element,
    // otherwise from the native <select>.
    currentSlug() {
        if (!this.hasSelectTarget) return ""
        const ts = this.selectTarget.tomselect
        const value = ts ? ts.getValue() : this.selectTarget.value
        return (Array.isArray(value) ? value[0] : value) || ""
    }
}
